import { useState, useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'
import FloatingCTA from './components/FloatingCTA'
import { fetchSiteSettings } from './lib/cms'

import HomePage from './pages/HomePage'
import BrugteBilerPage from './pages/BrugteBilerPage'
import ServiceeftersynPage from './pages/ServiceeftersynPage'
import DaekhotelPage from './pages/DaekhotelPage'
import DaekskiftPage from './pages/DaekskiftPage'
import ElbilServicePage from './pages/ElbilServicePage'
import VinterdaekPage from './pages/VinterdaekPage'
import AutovaerkstedBillundPage from './pages/AutovaerkstedBillundPage'
import AutovaerkstedGrindstedPage from './pages/AutovaerkstedGrindstedPage'
import FinansieringPage from './pages/FinansieringPage'
import OmOsPage from './pages/OmOsPage'
import KontaktPage from './pages/KontaktPage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'

export default function App() {
  const [settings, setSettings] = useState(null)

  useEffect(() => {
    fetchSiteSettings().then((data) => {
      setSettings(data)
    })
  }, [])

  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-white text-gray-900">
        <Header settings={settings} />

        <main className="flex-grow">
          <Routes>
            {/* Primary Scraped Routes */}
            <Route path="/" element={<HomePage settings={settings} />} />
            <Route path="/brugte-biler" element={<BrugteBilerPage settings={settings} />} />
            <Route path="/serviceeftersyn" element={<ServiceeftersynPage settings={settings} />} />
            <Route path="/daekhotel" element={<DaekhotelPage settings={settings} />} />
            <Route path="/daekskift" element={<DaekskiftPage settings={settings} />} />
            <Route path="/elbil-service" element={<ElbilServicePage settings={settings} />} />
            <Route path="/vinterdaek" element={<VinterdaekPage settings={settings} />} />
            <Route
              path="/autovaerksted-billund"
              element={<AutovaerkstedBillundPage settings={settings} />}
            />
            <Route
              path="/autovaerksted-grindsted"
              element={<AutovaerkstedGrindstedPage settings={settings} />}
            />
            <Route path="/finansering" element={<FinansieringPage settings={settings} />} />
            <Route path="/om-os" element={<OmOsPage settings={settings} />} />
            <Route path="/kontakt" element={<KontaktPage settings={settings} />} />

            {/* Permanent Redirects from old URL variations to prevent broken links */}
            <Route path="/finansiering" element={<Navigate to="/finansering" replace />} />
            <Route path="/autovaerksted" element={<Navigate to="/serviceeftersyn" replace />} />
            <Route
              path="/autovaerksted/serviceeftersyn"
              element={<Navigate to="/serviceeftersyn" replace />}
            />
            <Route path="/autovaerksted/daekhotel" element={<Navigate to="/daekhotel" replace />} />
            <Route path="/autovaerksted/daekskift" element={<Navigate to="/daekskift" replace />} />
            <Route
              path="/autovaerksted-billund/daekskift"
              element={<Navigate to="/daekskift" replace />}
            />
            <Route
              path="/autovaerksted-billund/daekhotel"
              element={<Navigate to="/daekhotel" replace />}
            />

            {/* Dedicated Status Routes */}
            <Route path="/403" element={<ForbiddenPage settings={settings} />} />
            <Route path="/404" element={<NotFoundPage settings={settings} />} />
            <Route path="*" element={<NotFoundPage settings={settings} />} />
          </Routes>
        </main>

        <Footer settings={settings} />

        {/* Global Floating CTA Buttons with Customer Contact Methods */}
        <FloatingCTA settings={settings} />
      </div>
    </HelmetProvider>
  )
}
